import {getFactionIconPath} from './getFactionIconPath';
import {getFactionRankIconPath} from './getFactionRankIconPath';
import {getFactionSkinIconPath} from '../../configs/factions/skins/allFactionSkins';
import {getRankSkinLeague} from '../../configs/rankSkins';

export function resolveFactionSkinIconPath(factionId, skinId) {
  if (!skinId || skinId === `${factionId}_default`) {
    return getFactionIconPath(factionId);
  }

  const rank = getRankSkinLeague(skinId);
  if (rank) {
    return getFactionRankIconPath(factionId, rank);
  }

  return getFactionSkinIconPath(skinId);
}
